import { NavLink } from "react-router-dom";
import { publicUser } from "../../../../../../globals/route-names";
import SectionSideAdvert from "./section-side-advert";
import JobZImage from "../../../../../common/jobz-img";
import {enLangTranslation, uaLangTranslation} from "../../../../../../globals/constants";

function SectionJobsSidebar2({ _config }) {
    const lang = localStorage.getItem('language') || 'en';
    const uaLang = uaLangTranslation;
    const enLang = enLangTranslation;
    const translation = lang === 'en' ? enLang : uaLang;

    return (
        <>
            <div className="side-bar mb-4">
                <div className="twm-s-info2-wrap mb-5">
                    <div className="twm-s-info2">
                        <h4 className="section-head-small mb-4">{translation.jobInfo.title}</h4>
                        <ul className="twm-job-hilites2">
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-calendar-alt" />
                                    <span className="twm-title">{translation.jobInfo.date}</span>
                                    <div className="twm-s-info-discription">{translation.jobInfo.dateValue}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-map-marker-alt" />
                                    <span className="twm-title">{translation.jobInfo.location}</span>
                                    <div className="twm-s-info-discription">{translation.jobInfo.locationValue}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-user-tie" />
                                    <span className="twm-title">{translation.jobInfo.job}</span>
                                    <div className="twm-s-info-discription">{_config.jobTitle}</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-clock" />
                                    <span className="twm-title">{translation.jobInfo.experience}</span>
                                    <div className="twm-s-info-discription">{translation.jobInfo.experienceValue}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {
                _config.showJobInfo &&
                <div className="twm-s-info3-wrap mb-5">
                    <div className="twm-s-info3">
                        <div className="twm-s-info-logo-section">
                            <div className="twm-media">
                                <JobZImage src="images/jobs-company/pic1.jpg" alt="#" />
                            </div>
                            <h4 className="twm-title">Senior Web Designer , Developer</h4>
                        </div>
                        <ul>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-building" />
                                    <span className="twm-title">Company</span>
                                    <div className="twm-s-info-discription">Software Development</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-mobile-alt" />
                                    <span className="twm-title">Phone</span>
                                    <div className="twm-s-info-discription">+291  560 56456</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-at" />
                                    <span className="twm-title">Email</span>
                                    <div className="twm-s-info-discription">thewebmaxdemo@gmail.com</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-desktop" />
                                    <span className="twm-title">Website</span>
                                    <div className="twm-s-info-discription">https://themeforest.net</div>
                                </div>
                            </li>
                            <li>
                                <div className="twm-s-info-inner">
                                    <i className="fas fa-map-marker-alt" />
                                    <span className="twm-title">Address</span>
                                    <div className="twm-s-info-discription">1363-1385 Sunset Blvd Angeles, CA
                                        90026 ,USA</div>
                                </div>
                            </li>
                        </ul>
                        <NavLink to={publicUser.pages.ABOUT} className=" site-button">Vew Profile</NavLink>
                    </div>
                </div>
            }
        </>
    )
}

export default SectionJobsSidebar2;